

















































































































































import { PersonalInformation } from '@/models/CeremonyFormModel';
import Vue from 'vue';

export default Vue.extend({
  props: {
    checkMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      personal: new PersonalInformation(),
      informMethods: [
        'textmsg',
        'email',
        'line',
        'wechat',
        'letter',
      ],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.personal = this.$store.state.form.ceremonyForm.personalInformation;
    },
    saveInfo(move: string) {
      this.$store.commit('updatePersonalInformation', this.personal);
      if (move === 'next') {
        this.$router.push('longevity');
      }
    },
  },
});
